import { UPDATE_TICKET_DETAILS, UPDATE_TICKET_DETAILS_SUCCESS, UPDATE_TICKET_DETAILS_ERROR, UPDATE_TICKET_DETAILS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateTicketDetails = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TICKET_DETAILS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TICKET_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TICKET_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_TICKET_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateTicketDetails;
